export { default } from '@ember/object';

/**
  @module @ember-data/serializer
*/